export const GeneralPracticesApiUrls = {
  practices: '/medical-orders/general-practices',
};
